import { useNavigate } from "react-router-dom";

import { useState } from "react";
import "../Login/styles.scss";
import inovaLogo from "../../assets/inova@2x.png";
import api from "../../services/api";

function Login() {
  let navigate = useNavigate();
  const [values, setValues] = useState({});

  const handleSubmit = async (e) => {
    console.log(values);
    e.preventDefault();
    try { await api.post("/recuperarsenha", values);
      console.log(values);
      navigate("/RNovasenha");
    } catch (error) {}
  };

  const handleChange = (event) => {
    setValues((prevValues) => ({
      ...prevValues,
      [event.target.name]: event.target.value,
    }));
  };

  return (
    <div className="container-login">
      <div className="content-1">
        <img src={inovaLogo} style={{ width: "200px" }} alt="logo" />

        <div className="camp">
          <label className="text-gray">E-mail</label>
          <input type="text" name="email" onChange={(e) => handleChange(e)} />
        </div>
        <button onClick={handleSubmit}>Entrar</button>
      </div>
    </div>
  );
}

export default Login;
